export default __webpack_public_path__ + "static/media/sunsculpted11.3838f058.jpg";